export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/combination-visit-arrow.1853796c-1e51d7.svg";